import styled from 'styled-components'

export const Input = styled.input`
  height: 36px;
  border-radius: 4px;
  width: 100%;
  border: solid;
  border-color: #ececec;
  border-width: 1px;
  padding-left: 8px;
  color: #585858;
  outline:none !important;
    &:focus {
      outline:none !important;
    }
`

export const TextArea = styled.textarea`
  border-radius: 4px;
  width: 100%;
  border-bottom: 28px solid #fff;
  border: solid;
  border-color: #ececec;
  border-width: 1px;
  padding-top:8px;
  padding-left: 8px;
  padding-right:8px;
  color: #585858;
  resize: none;
  outline:none !important;
    &:focus {
      outline:none !important;
    }
`



// WEBPACK FOOTER //
// ./src/elements/Input.ts